import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import GossipChannel from "./components/GossipChannel";
import FeatureStory from "./components/FeatureStory";
import TimelineSection from "./components/TimelineSection";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="min-h-screen w-full bg-background-50 text-foreground-900">
      <Navbar />
      <Hero />
      <Trending />
      <GossipChannel />
      <FeatureStory />
      <TimelineSection />
      <AboutSection />
      <FaqSection />
      <SubscribeSection />
      <Footer />
    </main>
  );
}